export default __webpack_public_path__ + "static/phone2-abd16a80ccf593ccb40772bbafd500e5.jpg";